// Copyright (c) 2024 Deere & Company

const amountOfUseRequestSortOptions = [
    {
        displayName: 'CREATED',
        path: ['createdOn']
    }
];

export default amountOfUseRequestSortOptions;



// WEBPACK FOOTER //
// ./src/tcsm/wip/services/amount-of-use-request-sort-options.js